// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { css, StyleSheet } from 'aphrodite/no-important'
import PropTypes from 'prop-types'
import React from 'react'
import { commonPatterns } from '../../../../utils/enhancedTestIds'
import { ProfilePicture } from '../ProfilePicture'

export default function ResidentPictureName(props) {
  const { data, isLogRemoved, onSelect, style, testId } = props

  const redirect = () => onSelect(`residents/${data.id}/profile`)
  if (!data || !data.id) return <div style={styles.residentContainer} />

  const containerStyle = { ...styles.residentContainer, ...style }

  return (
    <div
      style={containerStyle}
      data-testid={testId ? `${testId}-resident-container` : undefined}
    >
      <div
        className={css(classes.clickable)}
        onClick={redirect}
        data-testid={testId ? `${testId}-resident-picture` : undefined}
      >
        <ProfilePicture
          className={
            isLogRemoved
              ? css(classes.profilePicGreyed)
              : css(classes.profilePic)
          }
          url={data.picture}
          size={46}
        />
      </div>
      <a
        className={`${css(classes.title)} ${css(classes.clickable)}`}
        onClick={redirect}
        style={{
          marginTop: 12,
          color: isLogRemoved ? colors.darkgrey : null,
          overflowWrap: 'anywhere'
        }}
        data-testid={testId ? `${testId}-resident-name` : undefined}
      >
        {data.name.first} {data.name.last}
      </a>
    </div>
  )
}

ResidentPictureName.propTypes = {
  data: PropTypes.object,
  isLogRemoved: PropTypes.bool,
  onSelect: PropTypes.func,
  style: PropTypes.object,
  testId: PropTypes.string
}

const styles = {
  residentContainer: {
    display: 'flex',
    marginRight: 12,
    minWidth: 160
  }
}

const classes = StyleSheet.create({
  clickable: {
    cursor: 'pointer'
  },
  profilePic: {
    marginRight: 12
  },
  profilePicGreyed: {
    marginRight: 12,
    opacity: 0.2
  },
  residentContainer: {
    display: 'flex',
    marginRight: 12,
    width: '25%'
  },
  title: {
    color: colors.black,
    display: 'block',
    fontWeight: 600
  }
})
